import "vite/modulepreload-polyfill";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/400-italic.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import "@fontsource/ibm-plex-mono/700.css";
import "./index.css";

import { VueQueryPlugin } from "@tanstack/vue-query";
import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";

import { createDepot } from "./lib/depot";
import PlaygroundApp from "./playground/PlaygroundApp.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [],
});

// Create the Vue app
const app = createApp(PlaygroundApp);

app.use(router);

// Configure Vue Query
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        gcTime: 5 * 60_000, // 5 minutes
        staleTime: 30_000, // 30 seconds
        // Disable most queries in playground mode. Some are re-enabled manually using `enabled: true` in each query.
        enabled: false,
      },
    },
  },
});

app.use(createDepot());
window.ACTIVE_NEWSLETTER_ID = "";
window.HYDRATED_PAYLOAD = {};
window.DEBUG = false;

app.mount("#app");

export default app;
